import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpriteProperties } from "@lib/titan2/dist/game/control/properties/SpriteProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { LoaderFontStyle } from "@lib/titan2/dist/game/view/style/CommonFontStyle";
import { GameLang } from "../lang/GameLang";
import { GameLoaderStyle } from "../style/GameStyle";
import { GameLoaderFontStyle } from "../style/GameFontStyle";
import { Rectangle, Point } from "pixi.js";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { LoaderStyle } from "@lib/titan2/dist/game/view/style/CommonStyle";
import { AbstractLoaderDialogProperties } from "@lib/titan2-slingo/dist/game/view/abstract/properties/AbstractLoaderDialogProperties";
/**
 * LoaderDialogProperties.ts
 */
export class GameLoaderDialogProperties extends AbstractLoaderDialogProperties {
    equals(other) {
        return super.equals(other) &&
            this.maskProperties.x === other.maskProperties.x &&
            this.maskProperties.y === other.maskProperties.y &&
            this.maskProperties.width === other.maskProperties.width &&
            this.maskProperties.height === other.maskProperties.height &&
            this.copyrightProperties.equals(other.copyrightProperties) &&
            this.progressBarForegroundProperties.equals(other.progressBarForegroundProperties) &&
            this.progressBarMaskProperties.x === other.progressBarMaskProperties.x &&
            this.progressBarMaskProperties.y === other.progressBarMaskProperties.y &&
            this.progressBarMaskProperties.width === other.progressBarMaskProperties.width &&
            this.progressBarMaskProperties.height === other.progressBarMaskProperties.height &&
            this.genericWinProperties.equals(other.genericWinProperties) &&
            this.genericSlingoProperties.equals(other.genericSlingoProperties) &&
            this.infoFieldFooterProperties.equals(other.infoFieldFooterProperties) &&
            this.progressBarOffsetStart.equals(other.progressBarOffsetStart) &&
            this.progressBarOffsetEnd.equals(other.progressBarOffsetEnd);
    }
    setDefaultValues() {
        super.setDefaultValues();
        this.maskProperties = new Rectangle(0, 0, 2436, 1280);
        this.copyrightProperties = new TextFieldProperties(LoaderFontStyle.COPYRIGHT, new Point(640, 2220), null, ControlConstants.CENTER, ControlConstants.CENTER, new Point(980, 190)).setMultiline(true);
        this.progressBarBackgroundProperties = new SpriteProperties(GameLoaderStyle.PROGRESS_BAR_BACKGROUND, GameLoaderStyle.MODULE);
        this.progressBarProperties = new SpriteProperties(GameLoaderStyle.PROGRESS_BAR, GameLoaderStyle.MODULE);
        this.progressBarForegroundProperties = new SpriteProperties(GameLoaderStyle.PROGRESS_BAR_FOREGROUND, GameLoaderStyle.MODULE);
        this.progressBarMaskProperties = new Rectangle(0, 0, 430, 70);
        this.progressBarOffsetStart = new Point(-438, 0);
        this.progressBarOffsetEnd = new Point(0, 0);
        this.genericWinProperties = new TextFieldProperties(GameLoaderFontStyle.INFO_FIELD_LINE_1, new Point(350, 380), GameLang.LOADER_GUIDE_BODY_0, ControlConstants.CENTER, ControlConstants.CENTER, new Point(460, 290)).setMultiline(true);
        this.genericSlingoProperties = new TextFieldProperties(GameLoaderFontStyle.INFO_FIELD_LINE_1, new Point(975, 510), GameLang.LOADER_GUIDE_BODY_1, ControlConstants.CENTER, ControlConstants.CENTER, new Point(670, 245)).setMultiline(true);
        this.infoFieldFooterProperties = new TextFieldProperties(LoaderFontStyle.COPYRIGHT, new Point(1218, 1200), null, ControlConstants.CENTER, ControlConstants.BOTTOM, new Point(2000, 200)).setMultiline(true);
        this.enLocaleWinContainer = new AbstractViewProperties(new Point(130, 346));
        this.enLocaleWinContainer.scale.set(1, 1);
        this.enLocaleWinProperties = [
            new TextFieldProperties(GameLoaderFontStyle.WIN_FIELD_SMALL, new Point(30, 25), null),
            new TextFieldProperties(GameLoaderFontStyle.WIN_FIELD_LARGE, new Point(0, 110), null),
        ];
        this.enLocaleSlingoContainer = new AbstractViewProperties(new Point(730, 521));
        this.enLocaleSlingoContainer.scale.set(0.9);
        this.enLocaleSlingoProperties = [
            new TextFieldProperties(GameLoaderFontStyle.INFO_FIELD_LINE_1, new Point(52, 35), null),
            new TextFieldProperties(GameLoaderFontStyle.INFO_FIELD_LINE_2, new Point(152, 7), null),
        ];
        this.enLocaleTextGlow = new SpriteProperties("Glow", LoaderStyle.MODULE, new Point(60, 252), null, new Point(0.5, 0.5));
    }
}
//# sourceMappingURL=LoaderDialogProperties.js.map